module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-12-36a0dd5162c16b05e67ab85a403adb47.jpg";